import { MemberState, Invoice, Contact } from '../interface/MemberInterface'
import { push } from 'connected-react-router'
import { authHeader, authHeader_ForPost } from '../javascript/auth-header';


export function loadMembers() {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/Admin/";
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var members_sorted = json.sort((a, b) => { return a.university - b.university });
                dispatch({
                    type: "LOAD_MEMBERS",
                    payload: members_sorted
                });
                //dispatch(getMemberDetail(members_sorted[0].display_id));
            });
    };
}

export function unloadMembers() {
    return dispatch => {
        dispatch({
            type: "UNLOAD_MEMBERS",
            payload: ""
        });
    };
}

export function getMemberDetail(display_id) {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/Admin/member_detail/" + display_id;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_MEMBER_DETAIL",
                    payload: json
                });
            });
    };
}

export function updateContact(contact: Contact, method) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = "/IRISReportsMicroservice/api/Admin/" + method + "/";

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "contact_id": contact.contact_id,
                "display_id": contact.display_id,
                "firstname": contact.firstname,
                "lastname": contact.lastname,
                "primary_contact": contact.primary_contact,
                "contact_type_1": contact.contact_type_1,
                "contact_type_2": contact.contact_type_2,
                "contact_type_3": contact.contact_type_3,
                "contact_title": contact.contact_title,
                "email": contact.email,
                "phone": contact.phone,
                "notes": contact.notes
            })
        })
            .then(response => {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "UPDATE_CONTACT",
                    payload: json
                });
            });
    };
}


export function addInvoice(invoice: Invoice) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = "/IRISReportsMicroservice/api/add_invoice/";

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "display_id": invoice.display_id,
                "invoice_type": invoice.invoice_type,
                "date_invoice_requested": invoice.date_invoice_requested,
                "date_invoice_sent": invoice.date_invoice_sent,
                "date_invoice_paid": invoice.date_invoice_paid,
                "date_of_next_invoice": invoice.date_of_next_invoice,
                "invoice_period_from": invoice.invoice_period_from,
                "invoice_period_to": invoice.invoice_period_to,
                "fiscal_year_end": invoice.fiscal_year_end,
                "member_year": invoice.member_year,
                "notes": invoice.notes
            })
        })
        .then(response => {
            return response.json();
        })
        .then(function (json) {
            dispatch({
                type: "ADD_INVOICE",
                payload: json
            });
        });
    };
}

